<script>
import VAutocompleteSpeaker from "@/components/VAutocomplete/VAutocompleteSpeaker.vue";
import VAutocompleteSession from "@/components/VAutocomplete/VAutocompleteSession.vue";
import CommonRules from "@/mixins/CommonRules";
import ThesesTypes from "@/mixins/dictionaries/ThesesTypes";
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";
import _ from "lodash";
import IsolatedRender from "@/components/commonComponents/IsolatedRender.vue";
import Languages from "@/mixins/dictionaries/Languages";
import VCurrencyInput from "@/components/commonComponents/VCurrencyInput.vue";

export default {
    name: "QuotesModalCommon",
    components: {
        VCurrencyInput,
        IsolatedRender,
        AjaxLoad,
        VAutocompleteSession,
        VAutocompleteSpeaker,
    },
    mixins: [
        CommonRules,
        ThesesTypes,
        Languages,
    ],
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
        idProject: {
            type: String,
        },
        idEventsBitrix: {
            type: Number,
        },
        idForumsBitrix: {
            type: Number,
        },
        isDisabledField: {
            type: Function,
        },
        idQuotes: {
            type: Number,
        },
    },
    data() {
        return {
            idSessionBitrix: null,
            fontSizeInputOptions: {
                valueRange: {min: 1, max: 50},
                precision: 2,
            },
        };
    },
    methods: {
        getThesis(v) {
            return [
                _.find(this.dictionaries.thesesTypes, {id: v.type}).name,
                v.name
            ].join(": ");
        },
        onChangeIsDeclined(v) {
            if (v) {
                this.value.is_bright = 0;
                this.value.is_summary = 0;
            }
        },
        onChangeIsBrightOrSummary(v) {
            if (v) {
                this.value.is_declined = 0;
            }
        },
    },
}
</script>

<template>
    <v-container>
        <v-row>
            <v-col class="pl-0 py-0" :cols="12" :sm="4">
                <v-autocomplete
                    v-model="value.language"
                    :disabled="isDisabledField('language')"
                    :items="dictionaries.languages"
                    :rules="[rules.required]"
                    label="Язык"
                    class="required"
                    item-text="name"
                    item-value="id"
                ></v-autocomplete>
            </v-col>
            <v-col class="pa-0 d-flex justify-end" :cols="12" :sm="4">
                <v-switch
                    v-model="value.is_ai"
                    :disabled="isDisabledField('is_ai')"
                    :true-value="1"
                    :false-value="0"
                    label="Используется ИИ"
                    hide-details
                ></v-switch>
            </v-col>
            <v-col class="pr-0 py-0 d-flex justify-end" :cols="12" :sm="4">
                <v-switch
                    v-model="value.is_declined"
                    :disabled="isDisabledField('is_declined')"
                    :true-value="1"
                    :false-value="0"
                    @change="onChangeIsDeclined"
                    label="Не публиковать"
                    hide-details
                ></v-switch>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="pl-0 py-0" :cols="12" :sm="2">
                <ajax-load
                    :url="$apiUrl.getProjectDictionarySessionsTitlesUrl({id_project: idProject})"
                    :transform="response => response.data.data"
                    v-slot="{data, resolved}"
                >
                    <v-autocomplete
                        v-model="value.id_sessions_titles"
                        :disabled="isDisabledField('id_sessions_titles')"
                        :items="data"
                        :loading="!resolved || undefined"
                        item-value="id"
                        item-text="name"
                        label="Тип"
                        clearable
                    ></v-autocomplete>
                </ajax-load>
            </v-col>
            <v-col class="pl-0 py-0" :cols="12" :sm="7">
                <v-autocomplete-session
                    v-model="value.id_session_eps"
                    :id-sessions.sync="value.id_sessions"
                    :id-session-bitrix.sync="idSessionBitrix"
                    :id-project="idProject"
                    :id-forums-bitrix="idForumsBitrix"
                    :id-events-bitrix="idEventsBitrix"
                    :disabled="isDisabledField('id_session_eps')"
                    :rules="[rules.required]"
                    @input="value.id_sessions_summaries_theses = null"
                    label="Сессия"
                    class="required"
                ></v-autocomplete-session>
            </v-col>
            <v-col class="pr-0 py-0" :cols="12" :sm="3">
                <!-- @TODO: создание/редактирование тезиса -->
                <ajax-load
                    :active="!!value.id_sessions"
                    :url="$apiUrl.getSessionUrl({id_project: idProject, id: value.id_sessions})"
                    :transform="response => response.data.data.summary.theses"
                    v-slot="{data, active, resolved}"
                >
                    <v-autocomplete
                        v-model="value.id_sessions_summaries_theses"
                        :disabled="isDisabledField('id_sessions_summaries_theses')"
                        :items="active ? data : []"
                        :loading="active && !resolved"
                        :rules="[]"
                        :item-text="getThesis"
                        item-value="id"
                        label="Тезис"
                        class=""
                    ></v-autocomplete>
                </ajax-load>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="pa-0">
                <isolated-render v-slot="{}">
                    <v-autocomplete-speaker
                        v-model="value.id_speaker"
                        :speaker-position.sync="value.speaker_position"
                        :id-project="idProject"
                        :id-forums-bitrix="idForumsBitrix"
                        :id-events-bitrix="idEventsBitrix"
                        :id-session-bitrix="idSessionBitrix"
                        :language="value.language"
                        :disabled="isDisabledField('id_speaker')"
                        :rules="[rules.required]"
                        @input="value.photo = ''; speaker = null;"
                        label="Спикер"
                        class="required"
                        autofocus
                    ></v-autocomplete-speaker>
                </isolated-render>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="pa-0">
                <v-textarea
                    v-model="value.speaker_position"
                    :disabled="isDisabledField('speaker_position')"
                    :rules="[rules.requiredTrim, rules.minLength(3)]"
                    label="Должность"
                    class="required"
                    rows="1"
                ></v-textarea>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="pa-0">
                <v-textarea
                    v-model="value.text"
                    :disabled="isDisabledField('text')"
                    :rules="[rules.requiredTrim, rules.minLength(3)]"
                    label="Цитата"
                    class="required"
                ></v-textarea>
            </v-col>
        </v-row>
        <!--        <v-row>
                    <v-col class="pa-0">
                        &lt;!&ndash;
                        <v-switch
                            v-model="value.is_bright"
                            :disabled="isDisabledField('is_bright')"
                            :true-value="1"
                            :false-value="0"
                            @change="onChangeIsBrightOrSummary"
                            label="Яркая цитата"
                            hide-details
                        ></v-switch>
                        &ndash;&gt;
                        &lt;!&ndash;                <v-switch
                                            v-model="value.is_summary"
                                            :disabled="isDisabledField('is_summary')"
                                            :true-value="1"
                                            :false-value="0"
                                            @change="onChangeIsBrightOrSummary"
                                            label="Саммари"
                                            hide-details
                                        ></v-switch>&ndash;&gt;

                    </v-col>
                </v-row>-->
        <v-row class="pa-0">
            <v-col :cols="12" :sm="12" class="pa-0">
                <div class="hr-sect pa-0">Индивидуальный размер шрифта</div>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="pl-0 py-0">
                <v-currency-input
                    v-model.number="value.svg_speaker_name_font_size"
                    :disabled="isDisabledField('svg_speaker_name_font_size')"
                    label="…ФИО"
                    :options="fontSizeInputOptions"
                    :suffix="value.svg_speaker_name_font_size ? 'px' : null"
                ></v-currency-input>
            </v-col>
            <v-col class="py-0">
                <v-currency-input
                    v-model.number="value.svg_speaker_position_font_size"
                    :disabled="isDisabledField('svg_speaker_position_font_size')"
                    label="…должность"
                    :options="fontSizeInputOptions"
                    :suffix="value.svg_speaker_position_font_size ? 'px' : null"
                ></v-currency-input>
            </v-col>
            <v-col class="py-0">
                <v-currency-input
                    v-model.number="value.svg_text_font_size"
                    :disabled="isDisabledField('svg_text_font_size')"
                    label="…текст цитаты"
                    :options="fontSizeInputOptions"
                    :suffix="value.svg_text_font_size ? 'px' : null"
                ></v-currency-input>
            </v-col>
            <v-col class="py-0">
                <v-currency-input
                    v-model.number="value.svg_session_name_font_size"
                    :disabled="isDisabledField('svg_session_name_font_size')"
                    label="…сессии"
                    :options="fontSizeInputOptions"
                    :suffix="value.svg_session_name_font_size ? 'px' : null"
                ></v-currency-input>
            </v-col>
            <v-col class="py-0 pr-0">
                <v-currency-input
                    v-model.number="value.svg_ai_font_size"
                    :disabled="isDisabledField('svg_ai_font_size')"
                    label="…ИИ"
                    :options="fontSizeInputOptions"
                    :suffix="value.svg_ai_font_size ? 'px' : null"
                ></v-currency-input>
            </v-col>
        </v-row>

        <v-row class="pa-0">
            <v-col :cols="12" :sm="12" class="pa-0">
                <div class="hr-sect pa-0">Видео</div>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="pa-0">
                <v-currency-input
                    v-model.number="value.start_time"
                    :options="{valueRange: {min: 0, max: 1e12}, precision: 3}"
                    :disabled="isDisabledField('start_time')"
                    :rules="[rules.positiveNumber]"
                    label="Тайм-код"
                    class="required"
                ></v-currency-input>
            </v-col>
        </v-row>

        <!--
        <v-row>
            <v-col class="pa-0">
                <v-autocomplete
                    v-model="value.sessions_summaries_theses_type"
                    :disabled="isDisabledField('id_sessions_summaries_theses')"
                    :items="dictionaries.thesesTypes"
                    :rules="[rules.required]"
                    item-text="name"
                    item-value="id"
                    label="Тип тезиса"
                    class="required"
                ></v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="pa-0">
                <v-text-field
                    v-model="value.sessions_summaries_theses_name"
                    :disabled="isDisabledField('id_sessions_summaries_theses')"
                    :rules="[rules.required]"
                    label="Текст тезиса"
                    class="required"
                ></v-text-field>
            </v-col>
        </v-row>
        -->
    </v-container>
</template>

<style scoped lang="scss">
.hr-sect {
    display: flex;
    flex-basis: 100%;
    align-items: center;
    color: rgba(0, 0, 0, 0.35);
    margin: 8px 0;
    font-size: 12px;

    &:before, &:after {
        content: "";
        flex-grow: 1;
        background: rgba(0, 0, 0, 0.15);
        height: 1px;
        font-size: 0;
        line-height: 0;
        margin: 0 8px;
    }
}
</style>
